import * as constants from './constants'
import { deleteAsJson, fetchAsJson, postAsJson, putAsJson } from '@eig-builder/core-utils/helpers/fetch-helper'
import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'
import { getRuntimeConfig } from '@eig-builder/core-utils/helpers/runtime-config-helper'

export const loadSitesByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/sites'), {
    key: constants.GET_SITES_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadPaginatedSitesByAccount = (accountId, partnerId, pageSize, pageIndex) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/sites/${pageSize}/${pageIndex}`), {
    key: constants.GET_PAGINATED_SITES_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadCpanelSitesByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/sites/cpanel'), {
    key: constants.GET_CPANEL_SITES_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadManageServicesByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/services/manage'), {
    key: constants.GET_MANAGE_SERVICES_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const moveServiceToResource = (accountId, partnerId, billingId, oldResourceId, newResourceId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/services/move'),
    {
      billing_service_id: billingId,
      old_resource_id: oldResourceId,
      new_resource_id: newResourceId
    },
    {
      key: constants.POST_MOVE_SERVICE_TO_SITE,
      convertToCamelCase: true
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getContactsForSite = (accountId, partnerId, siteId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/sites/contacts/${siteId}`), {
    key: constants.GET_CONTACTS_BY_SITE,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const sendExternalPlatformEmail = (type, account, site) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/external-platform/email'),
    {
      siteId: site.id,
      email_type: type,
      account_type: account.accountType
    },
    {
      key: constants.POST_EXTERNAL_PLATFORM_EMAIL
    },
    {
      'X-CRM-AccountId': account.id,
      'X-CRM-PartnerId': account.partnerId
    }
  )
}

export const deleteSiteById = (siteId, accountId, partnerId) => {
  return deleteAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/sites/delete/${siteId}`),
    {},
    {
      key: constants.DELETE_RESTORE_SITE_BY_ID
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const restoreSiteById = (siteId, accountId, partnerId) => {
  return putAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/sites/restore/${siteId}`),
    {},
    {
      key: constants.DELETE_RESTORE_SITE_BY_ID
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const clearCacheSiteById = (siteId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/sites/clearcache/${siteId}`),
    {},
    {
      key: constants.CLEAR_CACHE_SITE_BY_ID
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const copyExpressSiteToLatest = (toEnvironment, siteId, accountId) => {
  const currentEnv = getRuntimeConfig()._env
  return fetchAsJson(
    `https://re-api.sitebuilder.latest.wzdev.co/v1.0/tools/copy?fromEnvironment=${currentEnv}&toEnvironment=${toEnvironment}&siteId=${siteId}&toAccountId=${accountId}`,
    {
      key: constants.COPY_EXPRESS_SITE_TO_LATEST,
      convertToCamelCase: true,
      fetchOptions: {
        headers: {
          'x-api-key': 'u9ReDNT3Pce7VnzOKwo6Z1KpHBe58MK7'
        }
      }
    }
  )
}

export const copyExpressSite = (body, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/sites/copy-express'),
    body,
    {
      key: constants.COPY_EXPRESS_SITE
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}
